import React from "react";
import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { CardSection } from "@design-system/Card/CardSection";
import { AccountingReportHeader } from "@components/accounting/AccountingReportHeader";
import { AccountingReportFooter } from "@components/accounting/AccountingReportFooter";
import { Card } from "@design-system/Card/Card";
import { GlTableCallbacks } from "../glDrillDown.lib";
import { AccountingReportFilters } from "../types";
import {
    AccountingReportContext,
    useAccountingReportContextValue,
} from "../AccountingReport.context";
import { useReportChrome } from "../useReportChrome";
import { BalanceSheetTable } from "./BalanceSheetTable";
import { BalanceSheetReport } from "./types";
import styles from "./BalanceSheetContent.module.scss";

interface Props {
    report: BalanceSheetReport;
    filters: AccountingReportFilters;
    chrome: ReportPresentationChrome;
    numberFormat: NumberFormatValues;
    generationDate: Date;
    onDrillDown: GlTableCallbacks["onDrillDown"];
}

export const BalanceSheetContent: React.FC<Props> = ({
    report,
    filters,
    chrome,
    numberFormat,
    generationDate,
    onDrillDown,
}) => {
    const resolvedChrome = useReportChrome({
        chrome,
        generationDate,
    });

    const accountingReportContext = useAccountingReportContextValue(
        filters,
        numberFormat,
    );

    return (
        <Card stacked sharpEdges fullPage>
            <AccountingReportContext.Provider value={accountingReportContext}>
                <CardSection className={styles.accountingReportHeader}>
                    <AccountingReportHeader chrome={resolvedChrome} />
                </CardSection>

                <BalanceSheetTable report={report} onDrillDown={onDrillDown} />
                <AccountingReportFooter chrome={resolvedChrome} />
            </AccountingReportContext.Provider>
        </Card>
    );
};
